module.exports = __webpack_public_path__ + "static/media/pokeballSprite.80910876.png";